export enum apiEnum {
  // Setting
  todo = "/todo",
  organizerSetting = "/OrganizerSetting",
  resourceTypes = "/RCClientApp/resource-types",
  allNodes = "/trees/all",
  getNodeByType = "/RCClientApp/locations/search",
  getResourcesRecommended = "/RCClientApp/Recommended",
  getOrganizerAssistant = "/RCClientApp/organizer-assistants",
  searchResources = "/RCClientApp/SearchResource",
  filterResources = "/RCClientApp/FilterResources",
  getAppData = "/RCClientApp/filters",
  addFavorites = "/RCClientApp/favorites/add",
  deleteFavorites = "/RCClientApp/favorites/delete",
  configuration = "/RCClientApp/configuration",
  resourcesTimeline = "/RCClientApp/timeline",
  getSelectedResource = "/RCClientApp/GetBookingResources",
  getAttendeeStatus = "/RCClientApp/users/availability-events",
  openOrder = "/OfficeAddin/OneStopOrder",
  viewMovingOrder = "/OfficeAddin/MovingOrder/ViewOrder",
  checkResourceSuitableForMovingOrder = "/api/OfficeApp/CheckResourcesSuitableForMovingOrder",
  createMovingOrderTemp = "/api/OfficeApp/CreateTempReservationForMovingOrder",
  deleteTempReservation = "/api/OfficeApp/DeleteTempReservation",
  savePlaceOrderSessionData = "/api/OfficeApp/SaveSessionData",
  getSuggestTime = "/RCClientApp/suggest-meeting-times",
  createTemp = "/RCClientApp/reservations/create-temp",
  updateTemp = "/RCClientApp/update-reservation-temp-date",
  saveMeetingType = "/RCClientApp/update-meeting-type",
  findRecentColleague = "/RCClientApp/FindColleague",
  getMeetingColleagues = "/RCClientApp/GetMeetingColleagues",
  getFloorplan = "/RCClientApp/FilterFloorplans",
  getResourceCalendarBoldDate = "/RCClientApp/GetBoldDateResources",
  getResourceCalendarSchedule = "/RCClientApp/GetMeetingResources",
}
